import React from 'react'

const AutomationOptionsAppleTv = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="49" height="49" viewBox="0 0 49 49" fill="none" className={className}>
    <path
      d="M41.36 1.5H7.82C4.32956 1.5 1.5 4.32956 1.5 7.82V41.36C1.5 44.8504 4.32956 47.68 7.82 47.68H41.36C44.8504 47.68 47.68 44.8504 47.68 41.36V7.82C47.68 4.32956 44.8504 1.5 41.36 1.5Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M17.2104 18.79C17.8484 18.0217 18.1638 17.036 18.0904 16.04C17.1186 16.1431 16.2236 16.6157 15.5904 17.36C14.9552 18.0837 14.6317 19.029 14.6904 19.99C15.1761 19.9986 15.6571 19.8948 16.096 19.6866C16.5349 19.4784 16.9197 19.1716 17.2204 18.79"
      fill="black"
    />
    <path
      d="M18.0298 20.1701C16.6298 20.0901 15.4498 20.9701 14.7798 20.9701C14.1098 20.9701 13.0898 20.2101 11.9898 20.2301C11.2693 20.251 10.5669 20.4605 9.95275 20.8378C9.33859 21.215 8.83418 21.7468 8.48983 22.3801C6.98983 24.9801 8.08983 28.8501 9.54983 30.9701C10.2598 31.9701 11.1098 33.1701 12.2398 33.1301C13.3698 33.0901 13.7198 32.4301 15.0098 32.4301C16.2998 32.4301 16.6798 33.1301 17.7998 33.1101C18.9198 33.0901 19.6998 32.1101 20.3998 31.0101C20.9136 30.2664 21.3146 29.451 21.5898 28.5901C20.9183 28.2906 20.3471 27.8041 19.9446 27.1888C19.5421 26.5735 19.3252 25.8553 19.3198 25.1201C19.33 24.4688 19.5027 23.8304 19.8223 23.2628C20.1419 22.6952 20.5982 22.2165 21.1498 21.8701C20.7979 21.3681 20.3353 20.9537 19.7978 20.659C19.2603 20.3642 18.6622 20.1969 18.0498 20.1701"
      fill="black"
    />
    <path
      d="M26.9603 18.15V21H29.2403V22.89H26.9603V29.64C26.9603 30.64 27.4103 31.17 28.4103 31.17C28.6903 31.17 28.9603 31.17 29.2303 31.11V33.01C28.7837 33.0789 28.3322 33.1123 27.8803 33.11C25.5203 33.11 24.6103 32.19 24.6103 29.89V22.89H22.8203V21.04H24.5903V18.15H26.9603Z"
      fill="black"
    />
    <path d="M37.2098 33H34.7098L30.5098 21.04H32.9998L35.9498 30.65H36.0098L38.9598 21.04H41.3998L37.2098 33Z" fill="black" />
  </svg>
)

export default AutomationOptionsAppleTv
